(function (doc, win) {
  if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)){//移动端
    sessionStorage.setItem('terminalType',1)
  }else{//pc端
    sessionStorage.setItem('terminalType',2)
  }
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if(sessionStorage.getItem('terminalType')==1){
        docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
      }else{
        docEl.style.fontSize = '16px'
      }
      // if(clientWidth>=750){
      //   docEl.style.fontSize = '60px';
      // }else{
      //   docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
      // }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/assets/js/rem.js